<template>
  <section class="why-choose-us-box" id="why-choose-us">
    <div class="why-choose-us-box-intro">
      <div class="section-container-header-box fade-up-animation">
        <p class="list-text">Why choose us</p>
      </div>
      <h2 class="why-choose-us-box-intro-heading">
        <p class="extra-large-text-list fade-up-animation">Reasons teams</p>
        <p class="extra-large-text-list special-text fade-up-animation">build with us.</p>
      </h2>
      <p class="body-text why-choose-us-box-intro-text fade-up-animation">
        No buzzwords — just the things that actually make working with us different, from the first call to long after
        launch.
      </p>
    </div>

    <ul class="why-choose-us-box-list">
      <li v-for="point in whyChooseUsPoints" :key="point.title" class="why-choose-us-box-list-item fade-up-animation">
        <span class="why-choose-us-box-list-item-badge" aria-hidden="true">
          <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M3 8.5L6.2 11.5L13 4.5" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
          </svg>
        </span>
        <div class="why-choose-us-box-list-item-content">
          <h3 class="heading-3" v-html="point.title"></h3>
          <p class="body-text" v-html="point.description"></p>
        </div>
      </li>
    </ul>
  </section>
</template>

<script lang="ts" setup>
import { useFadeUpObserver } from '@/composables/useFadeUpObserver';
import { whyChooseUsPoints } from '@/data/whyChooseUs';

useFadeUpObserver();
</script>
